import type { UserState, User } from "@/types";
import type { MutationTree } from "vuex";

// USER
export const LOAD_CURRENT_USER = "LOAD_CURRENT_USER";
export const LOAD_CURRENT_USER_SUCCESS = "LOAD_CURRENT_USER_SUCCESS";
export const LOAD_CURRENT_USER_FAILURE = "LOAD_CURRENT_USER_FAILURE";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const mutations: MutationTree<UserState> = {
  // USER
  [LOAD_CURRENT_USER](state: UserState) {
    state.user = { ...state.user, loading: true, error: null };
  },
  [LOAD_CURRENT_USER_SUCCESS](state: UserState, user: User) {
    state.user = { data: user, loading: false, error: null };
  },
  [LOAD_CURRENT_USER_FAILURE](state: UserState, error: string) {
    state.user = { ...state.user, loading: false, error: error };
  },
  [UPDATE_USER](state: UserState) {
    state.user = { ...state.user, loading: true, error: null };
  },
  [UPDATE_USER_SUCCESS](state: UserState, user: User) {
    state.user = { data: user, loading: false, error: null };
  },
  [UPDATE_USER_FAILURE](state: UserState, error: string) {
    state.user = { ...state.user, loading: false, error: error };
  },
};
